import { Box, FormControl, FormHelperText, Typography } from "@mui/material";
import MaterialInput from "../../../../../../components/MaterialInput";
import MaterialTypography from "../../../../../../components/MaterialTypography";
import MaterialBox from "../../../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialSelect from "../../../../../../components/MasterSelect";

import { useUserDetails } from "../../../../../../context/auth";

import "react-phone-input-2/lib/style.css";
import { Country, State, City } from "country-state-city";
import { BsEye } from "react-icons/bs";

const PersonalInformation = ({
  handleFileChange,
  employeeData,
  handleEmployeeDataChange,
  resources,
  togglePage,
}) => {
  const { validation, validationMessages } = useUserDetails();

  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            First Name <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="firstName"
          placeholder="eg. Ajith"
          value={employeeData.firstName}
          onChange={handleEmployeeDataChange}
          error={employeeData.firstNameStatus === "error" ? true : false}
          success={employeeData.firstNameStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
          inputProps={{
            style: { backgroundColor: "transparent" }, // or your desired color
          }}
        />
        {employeeData.firstNameStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              First Name should be maximum 20 characters long and can contain
              only alphabets
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.firstName && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.firstName}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Last Name <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="lastName"
          placeholder="eg. Kumar"
          value={employeeData.lastName}
          onChange={handleEmployeeDataChange}
          error={employeeData.lastNameStatus === "error" ? true : false}
          success={employeeData.lastNameStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.lastNameStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Last Name should be maximum 20 characters long and can contain
              only alphabets
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.lastName && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.lastName}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Father Name
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="fathername"
          placeholder="eg. Raja"
          value={employeeData.fathername}
          onChange={handleEmployeeDataChange}
          error={employeeData.fathernameStatus === "error" ? true : false}
          success={employeeData.fathernameStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.fathernameStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Last Name should be maximum 20 characters long and can contain
              only alphabets
            </FormHelperText>
          </FormControl>
        )}
      </Grid>

      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            DOB <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="dob"
          type="date"
          value={employeeData.dob}
          onChange={handleEmployeeDataChange}
          error={employeeData.dobStatus === "error" ? true : false}
          success={employeeData.dobStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
          inputProps={{
            max: new Date(new Date().setFullYear(new Date().getFullYear() - 18))
              .toISOString()
              .split("T")[0],
            min: new Date(new Date().setFullYear(new Date().getFullYear() - 60))
              .toISOString()
              .split("T")[0],
          }}
        />

        {employeeData.dobStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Date of birth must be between 18 and 60 years of age.
            </FormHelperText>
          </FormControl>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Email Id <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="email"
          placeholder="eg: ajithkumar@gmail.com"
          value={employeeData.email}
          onChange={handleEmployeeDataChange}
          error={employeeData.emailStatus === "error" ? true : false}
          success={employeeData.emailStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.emailStatus === "error" && (
          <FormControl error>
            <FormHelperText>Please enter a valid email address</FormHelperText>
          </FormControl>
        )}
        {validationMessages.email && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.email}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Gender <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="gender"
          value={employeeData.gender}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={resources.gender.map((value) => {
            return {
              value: value.value,
              label: value.label,
            };
          })}
          error={employeeData.genderStatus === "error" ? true : false}
          success={employeeData.genderStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.gender && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.gender}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Marital Status <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="martialstatus"
          value={employeeData.martialstatus}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={resources.martialstatus.map((value) => {
            return {
              value: value.value,
              label: value.label,
            };
          })}
          error={employeeData.martialstatusStatus === "error" ? true : false}
          success={
            employeeData.martialstatusStatus === "success" ? true : false
          }
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.maritalStatus && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.maritalStatus}
          </label>
        )}
      </Grid>

      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Address <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="address"
          multiline
          rows={3}
          // placeholder="eg. Kumar"
          value={employeeData.address}
          onChange={handleEmployeeDataChange}
          disabled={togglePage.view === true ? true : false}
          error={employeeData.addressStatus === "error" ? true : false}
          success={employeeData.addressStatus === "success" ? true : false}
        />
        {employeeData.addressStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Address must be between 1 and 250 characters.
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.address && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.address}
          </label>
        )}
      </Grid>

      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            State <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="state"
          value={employeeData.state}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={State.getStatesOfCountry("IN").map((value) => {
            return {
              value: value.name,
              label: value.name,
              isoCode: value.isoCode,
              countryCode: value.countryCode,
            };
          })}
          error={employeeData.stateStatus === "error" ? true : false}
          success={employeeData.stateStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.state && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.state}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            City <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="city"
          value={employeeData.city}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event'
          options={City.getCitiesOfState(
            employeeData.state?.countryCode || "",
            employeeData.state?.isoCode,
          ).map((value) => {
            return {
              value: value.name,
              label: value.name,
            };
          })}
          error={employeeData.cityStatus === "error" ? true : false}
          success={employeeData.cityStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.city && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.city}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Zip Code <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="zipcode"
          placeholder="eg. 123456"
          value={employeeData.zipcode}
          onChange={handleEmployeeDataChange}
          error={employeeData.zipcodeStatus === "error"}
          success={employeeData.zipcodeStatus === "success"}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.zipcodeStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Zip Code should be 5 to 8 characters long and contain only letters
              and numbers.
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.zipcode && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.zipcode}
          </label>
        )}
      </Grid>

      <Grid size={{ xs: 8, sm: 4, lg: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Contact Number <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="contactNumber"
          placeholder="eg: 7865344543"
          value={employeeData.contactNumber}
          onChange={handleEmployeeDataChange}
          disabled={togglePage.view === true ? true : false}
          error={employeeData.contactNumberStatus === "error" ? true : false}
          success={
            employeeData.contactNumberStatus === "success" ? true : false
          }
        />

        {employeeData.contactNumberStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              {" "}
              Contact Number must be exactly 10 digits with no spaces or special
              characters.
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.contactNumber && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.contactNumber}
          </label>
        )}
      </Grid>

      <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Emergency Number
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="emergencyNumber"
          placeholder="eg: 7865344543"
          value={employeeData.emergencyNumber}
          onChange={handleEmployeeDataChange}
          disabled={togglePage.view === true ? true : false}
          error={employeeData.emergencyNumberStatus === "error" ? true : false}
          success={
            employeeData.emergencyNumberStatus === "success" ? true : false
          }
        />

        {employeeData.emergencyNumberStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Emergency Number must be exactly 10 digits with no spaces or
              special characters.
            </FormHelperText>
          </FormControl>
        )}
      </Grid>

      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Aadhar Number <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="aadharnumber"
          placeholder="eg: 4606 9848 5156"
          value={employeeData.aadharnumber}
          onChange={handleEmployeeDataChange}
          error={employeeData.aadharnumberStatus === "error"}
          success={employeeData.aadharnumberStatus === "success"}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.aadharnumberStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              Aadhar Number should be exactly 12 digits long and in the format
              "xxxx xxxx xxxx".
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.aadharNumber && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.aadharNumber}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Aadhar Picture
          </MaterialTypography>

          {employeeData?.aadharImage &&
            typeof employeeData.aadharImage === "string" && (
              <a
                href={employeeData.aadharImage}
                target="_blank"
                rel="noopener noreferrer"
                title="View"
                style={{
                  marginLeft: "8px",
                  fontSize: "12px",
                  color: "#1976d2",
                }}
              >
                <BsEye />
              </a>
            )}
        </MaterialBox>

        <Box
          sx={{
            border: "1.5px dashed #ccc",
            borderRadius: "6px",
            padding: "6px",
            textAlign: "center",
            cursor: togglePage.view ? "default" : "pointer",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            backgroundColor: togglePage.view ? "#f5f5f5" : "inherit",
            "&:hover": { borderColor: togglePage.view ? "#ccc" : "#1976d2" },
          }}
        >
          {!togglePage.view && (
            <input
              type="file"
              name="Profile"
              title=""
              accept=".jpg,.jpeg,.png,.pdf"
              disabled={togglePage.view}
              onChange={(e) => handleFileChange(e, "aadharImage")}
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                opacity: 0,
                cursor: "pointer",
              }}
            />
          )}

          <Box display="flex" alignItems="center" gap={1}>
            {employeeData?.aadharImage &&
            typeof employeeData.aadharImage === "string" ? (
              employeeData.aadharImage.endsWith(".pdf") ? (
                // Show a simple PDF icon (SVG) for PDFs
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                  width="20"
                  fill="#d32f2f"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM13 9V3.5L18.5 9H13zm-2 9H8v-1.5h3.5V15H9v-1.5h2c.55 0 1 .45 1 1V18z" />
                </svg>
              ) : (
                // Image preview thumbnail
                <img
                  src={employeeData.aadharImage}
                  alt="Aadhar"
                  style={{
                    width: "24px",
                    height: "24px",
                    borderRadius: "3px",
                    objectFit: "cover",
                  }}
                />
              )
            ) : null}

            <Typography
              variant="caption"
              color="textSecondary"
              sx={{
                fontSize: "12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "150px",
              }}
            >
              {employeeData?.aadharImage
                ? typeof employeeData.aadharImage === "string"
                  ? employeeData.aadharImage.split("/").pop()
                  : employeeData.aadharImage.name
                : "Click to upload a file"}
            </Typography>
          </Box>
        </Box>
      </Grid>

      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            PAN Number <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="pannumber"
          placeholder="eg: ABCDE1234F"
          value={employeeData.pannumber}
          onChange={handleEmployeeDataChange}
          error={employeeData.pannumberStatus === "error"}
          success={employeeData.pannumberStatus === "success"}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.pannumberStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              PAN Number should be in the format "ABCDE1234F" (5 letters, 4
              digits, and 1 letter).
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.panNumber && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.panNumber}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            PAN Picture
          </MaterialTypography>

          {employeeData?.panImage &&
            typeof employeeData.panImage === "string" && (
              <a
                href={employeeData.panImage}
                target="_blank"
                rel="noopener noreferrer"
                title="View"
                style={{
                  marginLeft: "8px",
                  fontSize: "12px",
                  color: "#1976d2",
                }}
              >
                <BsEye />
              </a>
            )}
        </MaterialBox>

        <Box
          sx={{
            border: "1.5px dashed #ccc",
            borderRadius: "6px",
            padding: "6px",
            textAlign: "center",
            cursor: togglePage.view ? "default" : "pointer",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            backgroundColor: togglePage.view ? "#f5f5f5" : "inherit",
            "&:hover": { borderColor: togglePage.view ? "#ccc" : "#1976d2" },
          }}
        >
          {!togglePage.view && (
            <input
              type="file"
              name="Profile"
              title=""
              disabled={togglePage.view}
              accept=".jpg,.jpeg,.png,.pdf"
              onChange={(e) => handleFileChange(e, "panImage")}
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                opacity: 0,
                cursor: "pointer",
              }}
            />
          )}

          <Box display="flex" alignItems="center" gap={1}>
            {employeeData?.panImage &&
            typeof employeeData.panImage === "string" ? (
              employeeData.panImage.endsWith(".pdf") ? (
                // PDF icon
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                  width="20"
                  fill="#d32f2f"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM13 9V3.5L18.5 9H13zm-2 9H8v-1.5h3.5V15H9v-1.5h2c.55 0 1 .45 1 1V18z" />
                </svg>
              ) : (
                // Image thumbnail
                <img
                  src={employeeData.panImage}
                  alt="PAN"
                  accept="image/*,.pdf"
                  style={{
                    width: "24px",
                    height: "24px",
                    borderRadius: "3px",
                    objectFit: "cover",
                  }}
                />
              )
            ) : null}

            <Typography
              variant="caption"
              color="textSecondary"
              sx={{
                fontSize: "12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "150px",
              }}
            >
              {employeeData?.panImage
                ? typeof employeeData.panImage === "string"
                  ? employeeData.panImage.split("/").pop()
                  : employeeData.panImage.name
                : "Click to upload a file"}
            </Typography>
          </Box>
        </Box>
      </Grid>

      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Nominee Name
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="nomineeName"
          placeholder="eg. Ajith"
          value={employeeData.nomineeName}
          onChange={handleEmployeeDataChange}
          error={employeeData.nomineeNameStatus === "error" ? true : false}
          success={employeeData.nomineeNameStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
          inputProps={{
            style: { backgroundColor: "transparent" }, // or your desired color
          }}
        />
        {employeeData.nomineeNameStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              First Name should be maximum 20 characters long and can contain
              only alphabets
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.nomineeNameStatus && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.nomineeNameStatus}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Nominee Relationship
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="nomineeRelation"
          placeholder="eg. Father"
          value={employeeData.nomineeRelation}
          onChange={handleEmployeeDataChange}
          error={employeeData.nomineeRelationStatus === "error" ? true : false}
          success={
            employeeData.nomineeRelationStatus === "success" ? true : false
          }
          disabled={togglePage.view === true ? true : false}
          inputProps={{
            style: { backgroundColor: "transparent" }, // or your desired color
          }}
        />
        {employeeData.nomineeRelationStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              First Name should be maximum 20 characters long and can contain
              only alphabets
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.firstName && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.firstName}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Nominee Aadhar
          </MaterialTypography>

          {employeeData?.nomineeAadharImage &&
            typeof employeeData.nomineeAadharImage === "string" && (
              <a
                href={employeeData.nomineeAadharImage}
                target="_blank"
                rel="noopener noreferrer"
                title="View"
                style={{
                  marginLeft: "8px",
                  fontSize: "12px",
                  color: "#1976d2",
                }}
              >
                <BsEye />
              </a>
            )}
        </MaterialBox>

        <Box
          sx={{
            border: "1.5px dashed #ccc",
            borderRadius: "6px",
            padding: "6px",
            textAlign: "center",
            cursor: togglePage.view ? "default" : "pointer",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            backgroundColor: togglePage.view ? "#f5f5f5" : "inherit",
            "&:hover": { borderColor: togglePage.view ? "#ccc" : "#1976d2" },
          }}
        >
          {!togglePage.view && (
            <input
              type="file"
              name="Profile"
              title=""
              accept=".jpg,.jpeg,.png,.pdf"
              disabled={togglePage.view}
              onChange={(e) => handleFileChange(e, "nomineeAadharImage")}
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                opacity: 0,
                cursor: "pointer",
              }}
            />
          )}

          <Box display="flex" alignItems="center" gap={1}>
            {employeeData?.nomineeAadharImage &&
            typeof employeeData.nomineeAadharImage === "string" ? (
              employeeData.nomineeAadharImage.endsWith(".pdf") ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                  width="20"
                  fill="#d32f2f"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM13 9V3.5L18.5 9H13zm-2 9H8v-1.5h3.5V15H9v-1.5h2c.55 0 1 .45 1 1V18z" />
                </svg>
              ) : (
                <img
                  src={employeeData.nomineeAadharImage}
                  alt="Nominee Aadhar"
                  style={{
                    width: "24px",
                    height: "24px",
                    borderRadius: "3px",
                    objectFit: "cover",
                  }}
                />
              )
            ) : null}

            <Typography
              variant="caption"
              color="textSecondary"
              sx={{
                fontSize: "12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "150px",
              }}
            >
              {employeeData?.nomineeAadharImage
                ? typeof employeeData.nomineeAadharImage === "string"
                  ? employeeData.nomineeAadharImage.split("/").pop()
                  : employeeData.nomineeAadharImage.name
                : "Click to upload a file"}
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default PersonalInformation;
